import { render, staticRenderFns } from "./u-pagination-text-rounded.vue?vue&type=template&id=cc0b208e&scoped=true"
import script from "./u-pagination-text-rounded.vue?vue&type=script&lang=js"
export * from "./u-pagination-text-rounded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc0b208e",
  null
  
)

export default component.exports